import * as React from 'react';
import { Button, Checkbox, Col, Form, Row } from 'antd';
import Link from 'antd/lib/typography/Link';
import Title from 'antd/lib/typography/Title';

interface JoinMemberStep2Props {
  user: any;
  onPrev: (data: any) => void;
  onSuccess: (data: any) => void;
}

function JoinMemberStep2({ user, onPrev, onSuccess }: JoinMemberStep2Props) {
  const [form] = Form.useForm();

  const handleOpenNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener, noreferrer');
  };

  return (
    <>
      <Row justify={'center'} style={{ marginTop: '10px' }}>
        <Col>
          {/* <Title level={4}>${user.name}의 동의가 필요해요.</Title> */}
          <Title level={4}>{user.name}님의 동의가 필요해요.</Title>
        </Col>
      </Row>
      <Form
        name="basic"
        form={form}
        layout="vertical"
        initialValues={{}}
        onFinish={onSuccess}
      >
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="isTermsOfServiceEnabled"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            '서비스 이용약관을 확인 및 동의 부탁드립니다.',
                          ),
                        ),
                },
              ]}
            >
              <Checkbox style={{ width: '100%' }}>
                (필수){' '}
                <Link
                  onClick={() => {
                    const url =
                      'https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/HIGONGSA+-+%E1%84%89%E1%85%A5%E1%84%87%E1%85%B5%E1%84%89%E1%85%B3%E1%84%8B%E1%85%B5%E1%84%8B%E1%85%AD%E1%86%BC%E1%84%8B%E1%85%A3%E1%86%A8%E1%84%80%E1%85%AA%E1%86%AB.html';
                    handleOpenNewTab(url);
                  }}
                >
                  서비스 이용약관
                </Link>{' '}
                을 확인하였고, 이에 동의합니다.
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="isPrivacyPolicyEnabled"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            '개인정보처리방침을 확인 및 동의 부탁드립니다.',
                          ),
                        ),
                },
              ]}
            >
              <Checkbox style={{ width: '100%' }}>
                (필수){' '}
                <Link
                  onClick={() => {
                    const url =
                      'https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/HIGONGSA+-+%E1%84%80%E1%85%A2%E1%84%8B%E1%85%B5%E1%86%AB%E1%84%8C%E1%85%A5%E1%86%BC%E1%84%87%E1%85%A9%E1%84%8E%E1%85%A5%E1%84%85%E1%85%B5%E1%84%87%E1%85%A1%E1%86%BC%E1%84%8E%E1%85%B5%E1%86%B7.html';
                    handleOpenNewTab(url);
                  }}
                >
                  개인정보처리방침
                </Link>{' '}
                을 확인하였고, 이에 동의합니다.
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Col span={8}>
            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                style={{ width: '100%' }}
                disabled={
                  form.getFieldsError().filter(({ errors }) => errors.length)
                    .length > 0
                }
              >
                다음
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={8}>
            <Button
              htmlType="button"
              style={{ width: '100%' }}
              onClick={onPrev}
            >
              뒤로
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default JoinMemberStep2;
